// This is from https://www.youtube.com/watch?v=8pKjULHzs0s

import React from 'react';
import logo from './logo.svg';
import {Container,Row,Col,Button, Alert, Breadcrumb,Card,Form,Image,Navbar,Nav,NavDropdown,Div} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { createRoot } from 'react-dom/client'
import {TranslateToSpanish} from "./Functions.js"
import {TranslateToGerman} from "./Functions.js"
import {TranslateToFrench} from "./Functions.js"
import {RevertToEnglish} from "./Functions.js"
import Spain from './Images/spain.png';
import FrontPageHeaderImage from "./Images/FrontPageHeaderEnglish.jpg"
import FrontPageFirstRowImage from "./Images/FrontPageFirstRow.jpg"
import FrontPageThirdRowImage from "./Images/FrontPageThirdRow.jpg"
import FrontPageFourthRowImage from "./Images/FrontPageFourthRow.jpg"
import FrontPageFithRowImage  from "./Images/FrontPageFithRow.jpg" 
import FacebookImage from "./Images/Facebook.png"

import './App.css';

function App() {
  return ( 
  <div className="MainDiv ">  
<Container id="MainContainer">

    <title>Al & Rachel's Frendship site</title> 

    <div style={{backgroundColor: "lightGray"}} className="Language Buttons sticky-top">
      <Navbar className="justify-content-center"  variant="dark">
      <Button id='LanguageButton1' onClick={TranslateToSpanish} title="Española">
        Española
      </Button>
      <Button  id='LanguageButton2' onClick={TranslateToGerman} title="Deutsch">
        Deutsch
      </Button>
      <Button id='LanguageButton3' onClick={TranslateToFrench}  title="French">
        Francaise
      </Button>
      <Button id='LanguageButton4' onClick={RevertToEnglish} title="English">
        English
      </Button> 
      </Navbar>
      <hr></hr>
      <a href="https://www.facebook.com/AlanLane33" target="_blank">
        <img id="AlansFacebookPhoto" src={FacebookImage} alt="Facebook"></img>    
      </a>
      <a href="https://www.facebook.com/rachel.hardy.7583" target="_blank">
        <img id="RachelsFacebookPhoto" src={FacebookImage} alt="Facebook"></img>
      </a>
      <br></br> 
      <a id="AlansFacebookPhoto">
        Al's Facebook
      </a>
      <a id="RachelsFacebookText">
        Rachel's Facebook
      </a>
      <br></br>
    </div>

    {/*Header*/} 
    <div className="HeaderImage justify-content-center">

      <img id="FrontPageHeaderImage" src={FrontPageHeaderImage } className="img-fluid" alt="Front Page Header Image"></img>           

    </div>

    {/*ROW 1*/}
    <div className="row">
      <div className="col-sm-6">
          <h3 id="Row1MainText">
            “Life is not what you alone make it. 
            Life is the input of everyone who touched your life and every experience that entered it.
            We are all part of one another.”
          </h3>
          <p>Yuri Kochiyama</p>
      </div>
      
      <div className="col-sm-6">
          <img src={FrontPageFirstRowImage} className="img-fluid" alt="Front Page First Row Image"></img>   
      </div>
    </div>
  
    <div className="row">
      <div className="col-sm-4">
      </div>
      <div className="col-sm-4">
        <h1 id="Row2HeaderText">Our Adventures</h1>
      </div>
    </div>
    
    {/*ROW 3*/}
    <div className="container mt-5">
      <div id="Row3" className="row">
        <div className="col-sm-6">
          <img src={FrontPageThirdRowImage} className="img-fluid" alt="Front Page Third Row Image"></img>
        </div>
        <div className="col-sm-6">
          <h1 id="Row3HeaderText" >About our site</h1>
          <p id="Row3MainText">We like to explore our world slowly. Our preferred mode of transport is by bike and our preferred accommodation is our tent. Along our little adventures we meet so many interesting characters. We take photos, we chat, we move on and only after do we think “wouldn't it be nice to know how their little adventure went!” So we created this site so that maybe we could stay in touch...</p>
        </div>
      </div>
                
      {/*ROW 4*/}
      <div className="container mt-5">
        <div id="Row4"  className="row">
          <div className="col-sm-6">
            <h1 id="Row4HeaderText" >Pay it forward</h1>
            <p id="Row4MainText" >This is a great example of why we love our holidays. We met this couple in the middle of nowhere. They had a simple puncture but absolutely no tools. We stopped sorted them out and in return asked them to pay it forward. The next day we broke a tent pole... minor disaster, but the guy on the next pitch had a pole repair kit. We think this is some kind of pay it forward karma? </p>
          </div>
          <div className="col-sm-6">
            <img src={FrontPageFourthRowImage} className="img-fluid" alt="Front Page Fourth Row Image"></img>
          </div>
        </div>
      </div>
      </div>
      
      {/*ROW 5*/}
      <div className="container mt-5">
        <div id="Row5"className="row">
          <div className="col-sm-6">
            <img src={FrontPageFithRowImage} className="img-fluid" alt="Front Page Fith Row Image"></img>
          </div>
          <div className="col-sm-6">
            <h1 id="Row5HeaderText" >Whats next (2026)</h1>
            <p id="Row5MainText" >
                  We have our next mini adventure booked.<br></br><br></br> 
                  We plan on driving to Royan, dumping the car, jumping on our bikes and cycling south down tha atlantic coast, then over to Bordeaux, North to Cognac, where we are joing a freinds 60'th bithday celebrations.<br></br>
                  From there we have yet to decide our route, but probaly over to Ile d'Oleron??<br></br><br></br>
                  We hope to make friends along the way. And maybe keep in touch this time.
            </p>
          </div>
        </div>
      </div>
      <br></br>
      </Container>
  </div>

  );
}

export default App;
